import Template from '../../component/Template.js';
import { useEffect, useRef } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import SchoolIcon from '@mui/icons-material/School';

import ArrowForwardIcon from '@mui/icons-material/ForwardToInbox';
import ArrowForwardIcon2 from '@mui/icons-material/ArrowForward';

import UndoIcon from '@mui/icons-material/Undo';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';


import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import Select from 'react-select';
import $ from 'jquery';
import { Download } from '@mui/icons-material';

export default function Admin_ACA16ForwardedSignatureCoursesList() {

    const navigate = useNavigate();
    const isAuth = useAuth();

    if (isAuth === false) {
        navigate("/bos/");
    }

    const tableRef = useRef(null);

    const [loading, setlodaing] = useState(false);
    const { http } = Api();
    const [courseData, setCourseData] = useState([]);
    const [getSignatureCourseData, setSignatureCourseData] = useState([]);
    const [getOtherSignatureCourseData, setOtherSignatureCourseData] = useState([]);
    const [getCollegesData, setCollegesData] = useState([]);
    const [getSpecializationsData, setSpecializationsData] = useState([]);
    const [getDisciplinesData, setDisciplinesData] = useState([]);
    const [getStatData, setStatData] = useState([]);

    const [changedCollegeData, setChangedCollegeData] = useState(null);
    const [changedCollegesId, setChangedCollegesId] = useState(null);
    const [changedCollegeName, setChangedCollegeName] = useState(null);
    const [changedSpecializationData, setChangedSpecializationData] = useState(null);
    const [changedSpecializationId, setChangedSpecializationId] = useState(null);
    const [changedDisciplineData, setChangedDisciplineData] = useState(null);
    const [changedDisciplineId, setChangedDisciplineId] = useState(null);
    const [changedStatusData, setChangedStatusData] = useState([]);
    const [changedStatusId, setChangedStatusId] = useState([]);
    const [principalForwardedCount, setPrincipalForwardedCount] = useState(0);
    const [principalRevertedCount, setPrincipalRevertedCount] = useState(0);
    const [principalverifPendCount, setPrincipalverifPendCount] = useState(0);
    const [ACA16ForwardedToBOSCount, setACA16ForwardedToBOSCount] = useState(0);
    const [searchClicked, setSearchClicked] = useState(false);
    const [clearClicked, setClearClicked] = useState(false);
    const [displayCollegeName, setDisplayCollegeName] = useState(false);
    const [showReccModal, setShowReccModal] = useState(false);
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [courseToForward, setCourseToForward] = useState({ id: null, course_type: null });
    const [forwardNote, setForwardNote] = useState('');
    const [rejectNote, setRejectNote] = useState('');
    const [noteError, setNoteError] = useState(false);



    const [refresh, setrefresh] = useState(false);

    /* CUSTOME DATA TABLE BEGAINS HERE */

    const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' }); //sort
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [total_count, setTotal] = useState(null);

    const [showCourseModal, setShowCourseModal] = useState(false);
    const [selectedCourse, setSelectedCourse] = useState(null);

    const [selectedItem, setSelectedItem] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const [newRemark, setNewRemark] = useState('');
    const [selectedAdmissionYearID, setSelectedAdmissionYearID] = useState([]);
    const [selectedAdmissionYear, setSelectedAdmissionYear] = useState(null);




    const getStatusBadgeClass = (status) => {
        const statusMap = {
            'entered': 'bg-secondary',
            'forwareded_to_principal': 'bg-info text-dark',
            'teacher_submited': 'bg-primary',
            'principal_forwarded': 'bg-success',
            'principal_reverted': 'bg-warning text-dark',
            'aca16_forwarded_to_bos': 'bg-warning text-dark',
            'aca16_reverted_to_teacher': 'bg-warning text-dark',
            'aca16_reverted_to_bos': 'bg-warning text-dark',
            'coursecode_generated_by_aca16': 'bg-warning',
            'final_approved_by_aca16': 'bg-success',
            'bos_recommended_to_aca16': 'bg-info',
            'bos_reverted_to_teacher': 'bg-danger',
            'bos_rejected_course': 'bg-reject-txt'
        };

        return statusMap[status] || 'bg-secondary';
    };

    /* CUSTOME DATA TABLE ENDS HERE */


    // for kebabmenu 12/3/2024

    const [openKebabCourseId, setOpenKebabCourseId] = useState(null);

    // Function to toggle the kebab menu for a specific row

    const toggleKebabMenu = (courseId) => {
        // Toggle the open state for the specified course ID
        setOpenKebabCourseId(prevCourseId => (prevCourseId === courseId ? null : courseId));
    };


    // Close kebab menu when clicking anywhere on the screen -- 20/3/2024
    useEffect(() => {
        function handleClickOutside(event) {
            // Check if any kebab menu is open
            const isOpen = openKebabCourseId !== null;

            // Check if click is outside kebab menu and any kebab menu is open
            if (isOpen && !event.target.closest('.kebab-menu')) {
                // Close the open kebab menu
                setOpenKebabCourseId(null);
            }
        }

        document.body.addEventListener('click', handleClickOutside);
        return () => {
            document.body.removeEventListener('click', handleClickOutside);
        };
    }, [openKebabCourseId]);


    useEffect(() => {

        const fetchStudentList = async () => {



            const college_id = changedCollegesId ? changedCollegesId : 0;
            //const special_id = changedSpecializationId ? changedSpecializationId : '';
            const special_id = changedSpecializationId === undefined || changedSpecializationId === null ? '' : changedSpecializationId;

            const discipline_id = changedDisciplineId ? changedDisciplineId : 0;
            const entry_status = changedStatusId ? changedStatusId : 0;
            setCourseData([]);


            try {


                const response = await http.get(`/Admin/teacherSignatureCourseListforBOS`, {
                    params: {
                        admission_year: selectedAdmissionYearID || null,
                        college_id: college_id,
                        specialisation_id: special_id,
                        discipline_id: discipline_id,
                        entry_status: entry_status,
                    }
                });

                setCourseData(response.data.data);
                setSignatureCourseData(response.data.signature_course);
                setOtherSignatureCourseData(response.data.other_signature_course);
                if (response.data.data) {
                    if (college_id != 0 && college_id != null) {
                        setDisplayCollegeName(true);
                    }
                    else {
                        setDisplayCollegeName(false);
                    }
                }
                // setSpecializationsData(response.data.specialisations);
                // setDisciplinesData(response.data.disciplines);
                // setStatData(response.data.stat);
                // setPrincipalForwardedCount(response.data.stat.principal_forwarded);
                // setPrincipalRevertedCount(response.data.stat.principal_reverted);
                // setPrincipalverifPendCount(response.data.stat.principal_verification_pending);
                // setACA16ForwardedToBOSCount(response.data.stat.aca16_forwarded_to_bos);




                // console.log("bundilestatus", response.data.despatch_details);

            } catch (error) {
                if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
                    toast.error("Invalid Token");
                    setTimeout(() => {
                        navigate("/bos/");
                    }, 5000);
                } else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.response.data.message);
                }
            }
        };

        fetchStudentList();

    }, [refresh, searchClicked, clearClicked]);


    useEffect(() => {
        const college_id = changedCollegesId ? changedCollegesId : 0;

        const fetchCollegeList = async () => {
            try {
                const response = await http.get('/Admin/teacherSignatureCourseListforBOSfilter', {
                    params: { college_id }
                });

                setCollegesData(response.data.colleges);
                setCollegesData(response.data.colleges);
                // setSpecializationsData(response.data.specialisations);
                const specialData = response.data.specialisations;
                setDisciplinesData(response.data.disciplines);
                setStatData(response.data.status);


                if (!specialData || specialData.length === 0) {
                    setSpecializationsData([{ ugp_specialisation_id: "-1", ugp_specialisation_name: "No Specialization Course Added" }]);
                }
                else {
                    setSpecializationsData(response.data.specialisations);
                }

            } catch (error) {
                if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
                    toast.error("Invalid Token");
                    setTimeout(() => {
                        navigate("/bos/");
                    }, 5000);
                } else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.response?.data?.message || "An error occurred.");
                }
            }
        };

        fetchCollegeList();
    }, [changedCollegesId, navigate]);

    useEffect(() => {
        setSpecializationsData((prev) => {
            const alreadyExists = prev.some(item => item.ugp_specialisation_id === 0);

            if (!alreadyExists) {
                return [...prev, { ugp_specialisation_id: 0, ugp_specialisation_name: "Other Signature Course" }];
            }
            return prev;
        });
    }, [getSpecializationsData]);


    const handleadmissionyear = (selectedOptions) => {
        setSelectedAdmissionYearID(selectedOptions.value);
        setSelectedAdmissionYear(selectedOptions);

    };

    const handleCollegeChange = (selectedOption) => {
        setChangedCollegeData(selectedOption);
        setChangedCollegesId(selectedOption.value);
        setChangedCollegeName(selectedOption.label);
    };
    const handleSpecializationChange = (selectedOption) => {
        setChangedSpecializationData(selectedOption);
        setChangedSpecializationId(selectedOption.value);
    };
    const handleDisciplineChange = (selectedOption) => {
        setChangedDisciplineData(selectedOption);
        setChangedDisciplineId(selectedOption.value);
    };
    const handleStatusChange = (selectedOption) => {
        setChangedStatusData(selectedOption);
        setChangedStatusId(selectedOption?.value || null);
    };

    const allStatusMap = {
        final_approved_by_aca16: 'Final Approved',
        coursecode_generated_by_aca16: 'Course Code Generated',
        aca16_forwarded_to_bos: 'ACA16 Forwarded to BOS',
        aca16_reverted_to_bos: 'ACA16 Reverted to BOS',
        bos_recommended_to_aca16: 'BOS Recommended to ACA16',
        bos_reverted_to_teacher: 'BOS Reverted to Teacher',
        bos_rejected_course: 'BOS Rejected'
    };
    const statusOptions = Object.entries(allStatusMap).map(([value, label]) => ({
        value,
        label
    }));


    const handleClearFields = () => {

        setChangedCollegeData(null);
        setChangedCollegesId(null);
        setChangedCollegeName(null);
        setChangedSpecializationData(null);
        setChangedSpecializationId(null);
        setChangedDisciplineData(null);
        setChangedDisciplineId(null);
        setChangedStatusData([]);
        setChangedStatusId([]);
        setSelectedAdmissionYearID([]);
        setSelectedAdmissionYear(null);
        setClearClicked(!clearClicked); // Set clearClicked to true to trigger useEffect
        //setClearClicked(true); // Set clearClicked to true to trigger useEffect
    }



    const showCourseList = () => {
        
        setSearchClicked(prev => !prev); // toggle to re-trigger useEffect
    };

    const getCourseDetails = async (id) => {
        try {
            const response = await http.get(`College/getTeacherSignatureCourseDetails`, {
                params: { id }
            });


            setShowCourseModal(true);


            const data = response.data;
            setSelectedCourse({
                courseid: data.id,
                name: data.course_name,
                semester: data.semester,
                remarks: JSON.parse(data.remarks || '[]'),
                status: data.entry_status
            });


        } catch (error) {
            setShowCourseModal(false);

            if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
                toast.error("Invalid Token");
                setTimeout(() => {
                    navigate("/bos/");
                }, 5000);
            } else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
                toast.error(error.response.data.message);
            } else {
                toast.error(error.response?.data?.message || "Something went wrong.");
            }
        }
    };


    const BOS_Recommended = async () => {
        if (!forwardNote.trim()) {
            setNoteError(true);
            return;
        }
        setNoteError(false);
        try {
            const { id, course_type } = courseToForward;
            const response = await http.get(`Admin/forwardCourseListforBOS`, {
                params: {
                    id: id,
                    course_type: course_type,
                    remark: forwardNote,
                }
            });

            if (response?.data) {
                toast.success("Successfully recommended to the University(ACA16).");
                setOpenKebabCourseId(null);
                setShowReccModal(false);
                setCourseToForward({ id: null, course_type: null });
                setForwardNote('');
                setNoteError(false);
                setrefresh(prev => !prev);
            }
        } catch (error) {
            setOpenKebabCourseId(null);
            const res = error.response?.data;
            if (res?.http_status === 403 && res.status_code === "ERR37") {
                toast.error("Invalid Token");
                setTimeout(() => {
                    navigate("/bos/");
                }, 5000);
            } else if (res?.http_status === 429 && res.status_code === "ERR33") {
                toast.error(res.message);
            } else {
                toast.error(res?.message || "An unexpected error occurred.");
            }
        }
    };

    const handleReccCancel = () => {
        console.log("Closing modal");
        setShowReccModal(false);
        setCourseToForward({ id: null, course_type: null });
        setForwardNote('');
        setNoteError(false);

    }


    const BOS_Rejected = async () => {
        if (!rejectNote.trim()) {
            setNoteError(true);
            return;
        }
        setNoteError(false);
        try {
            const { id, course_type } = courseToForward;
            const response = await http.get(`Admin/rejectCourseListByBOS`, {
                params: {
                    id: id,
                    course_type: course_type,
                    remark: rejectNote,
                    section_name: 'BOS',
                    action_name: 'Rejected'
                }
            });

            if (response?.data) {
                toast.success("An email has been sent to corresponding Faculty");
                toast.success("Course was rejected successfully");
                setOpenKebabCourseId(null);
                setShowRejectModal(false);
                setCourseToForward({ id: null, course_type: null });
                setForwardNote('');
                setNoteError(false);
                setrefresh(prev => !prev);
            }
        } catch (error) {
            setOpenKebabCourseId(null);
            const res = error.response?.data;
            if (res?.http_status === 403 && res.status_code === "ERR37") {
                toast.error("Invalid Token");
                setTimeout(() => {
                    navigate("/bos/");
                }, 5000);
            } else if (res?.http_status === 429 && res.status_code === "ERR33") {
                toast.error(res.message);
            } else {
                toast.error(res?.message || "An unexpected error occurred.");
            }
        }
    };


    const handleRejectCancel = () => {
        console.log("Closing modal");
        setShowRejectModal(false);
        setCourseToForward({ id: null, course_type: null });
        setRejectNote('');
        setNoteError(false);

    }

    const setCourseRevert = async (courseid, status, remark) => {
        if (!remark) {
            toast.error("Please enter a remark");
            return;
        }
        if (status === 'bos_reverted_to_teacher') {

            toast.error("This course is already reverted by the BOS");
            return;
        }
        try {
            const response = await http.get(`Admin/revertCourseListforBOS`, {
                params: {
                    id: courseid,
                    remark: remark,
                    section_name: 'BOS',
                    action_name: 'Reverted'
                }
            });

            if (response?.data) {

                toast.success("An email has been sent to corresponding Faculty");
                toast.success("Course was reverted successfully");
                setShowCourseModal(false);
                setNewRemark('');
                setrefresh(prev => !prev);
            }
        } catch (error) {
            const res = error.response?.data;
            if (res?.http_status === 403 && res.status_code === "ERR37") {
                toast.error("Invalid Token");
                setTimeout(() => {
                    navigate("/bos/");
                }, 5000);
            } else if (res?.http_status === 429 && res.status_code === "ERR33") {
                toast.error(res.message);
            } else {
                toast.error(res?.message || "An unexpected error occurred.");
            }
        }
    };

    const handleGeneratePDF = async (id, ctype) => {
        setlodaing(true);
        try {
            const response = await http.get('/College/teacherSignatureCoursePreview', {
                params: {
                    id: id,
                    course_type: ctype

                },
                responseType: 'blob',
            });

            if (response && response.data) {
                // Create a URL for the downloaded file
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;

                // Set the file name and download the PDF
                link.setAttribute('download', `${localStorage.getItem('username')}_.pdf`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setlodaing(false);

                return Promise.resolve('PDF generated successfully');
            }
        } catch (error) {
            setlodaing(false);
            console.error('Error generating PDF:', error);
            return Promise.reject('Error generating PDF');
        }
    };





    /* CUSTOME DATA TABLE BEGAINS HERE */

    const handleSearchInputChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleSort = (column) => {
        const newSortBy = {
            column,
            direction: sortBy.column === column && sortBy.direction === 'asc' ? 'desc' : 'asc',
        };
        setSortBy(newSortBy);
    };

    useEffect(() => {
        const filteredAndSortedData = [...courseData].filter(courseDatas => {
            return (
                courseDatas.ugp_specialisation_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                courseDatas.course_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                courseDatas.discipline_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                courseDatas.admn_year?.toString().includes(searchQuery) ||
                courseDatas.faculty_name?.toLowerCase().includes(searchQuery.toLowerCase())
            );
        }).sort((a, b) => {
            if (sortBy.direction === 'asc') {
                return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
            } else {
                return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
            }
        });


        const itemsPerPage = 50;
        const startIndex = (currentPage - 1) * itemsPerPage;
        const paginatedData = filteredAndSortedData.slice(startIndex, startIndex + itemsPerPage);

        setfilteredAndSortedData(paginatedData);
        setTotalPages(Math.ceil(filteredAndSortedData.length / itemsPerPage));
        setTotal(filteredAndSortedData.length);

    }, [searchQuery, sortBy, courseData, currentPage]);


    const renderSortIcon = (columnName) => {
        if (sortBy.column === columnName) {
            return sortBy.direction === 'asc' ? <i className="fa fa-sort-up ml-1" aria-hidden="true"></i> : <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>;
        }
        return <i className="fa fa-sort ml-1" aria-hidden="true"></i>; // Show disabled sort icon
    };


    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    /* CUSTOME DATA TABLE END HERE */

    const customStyles = {
        menu: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
            scrollbarWidth: 'thin',
            scrollbarColor: '#888 #f1f1f1',
        }),

        /* Additional custom scrollbar styling for WebKit-based browsers */
        multiValue: (provided) => ({
            ...provided,
            '&::-webkit-scrollbar': {
                width: '8px',
            },
            '&::-webkit-scrollbar-track': {
                background: '#f1f1f1',
            },
            '&::-webkit-scrollbar-thumb': {
                background: '#888',
                borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb:hover': {
                background: '#555',
            },
        }),
    };




    // console.log(Name,selectedCourse);

    return (
        <>
            <ToastContainer />
            <Template>

                {loading ? (


                    <div className="container-fluid">
                        <div className="row justify-content-center align-items-center">
                            <div className="col-sm-12">
                                <div className="card h-100">
                                    <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                                        <div className="containeranimate">
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (


                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card">
                                    <div className="col-md-12">
                                        <div className="card-header">
                                            <div className="py-3 d-flex justify-content-between align-items-center">
                                                <h5>Signature Courses</h5>
                                            </div>
                                        </div>
                                        <div className="card-body pdg">

                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-2">
                                                        <label>Admission Year </label>
                                                        {/* <span className="errorclr">*</span> */}
                                                        <Select
                                                            maxMenuHeight={200}
                                                            menuPlacement="auto"
                                                            id="Adimission_year"
                                                            name="Adimission_year"
                                                            className="form"
                                                            styles={customStyles}
                                                            options={[
                                                                { value: '2024', label: '2024' },
                                                                { value: '2025', label: '2025' },
                                                                { value: '2026', label: '2026' },
                                                            ]}
                                                            value={selectedAdmissionYear}
                                                            onChange={handleadmissionyear}
                                                        />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label>College </label>
                                                        {/* <span className="errorclr">*</span> */}
                                                        <Select
                                                            maxMenuHeight={200}
                                                            menuPlacement="auto"
                                                            id="college_id"
                                                            name="college_id"
                                                            className="form"
                                                            styles={customStyles}
                                                            value={changedCollegeData}
                                                            options={getCollegesData && getCollegesData.map(college => ({
                                                                value: college.college_id,
                                                                label: college.college_name
                                                            }))}
                                                            onChange={handleCollegeChange}
                                                        />
                                                    </div>

                                                    <div className="col-md-3">
                                                        <label>Specialization</label>
                                                        <Select
                                                            maxMenuHeight={200}
                                                            menuPlacement="auto"
                                                            id="specialization_id"
                                                            name="specialization_id"
                                                            className="form"
                                                            styles={customStyles}
                                                            value={changedSpecializationData}
                                                            options={getSpecializationsData && getSpecializationsData.map(spec => ({
                                                                value: spec.ugp_specialisation_id,
                                                                label: spec.ugp_specialisation_name.trim(),
                                                                isDisabled: spec.ugp_specialisation_id == -1
                                                            }))}
                                                            onChange={handleSpecializationChange}
                                                        />
                                                    </div>

                                                    <div className="col-md-2">
                                                        <label>Discipline </label>
                                                        <Select
                                                            maxMenuHeight={200}
                                                            menuPlacement="auto"
                                                            id="discipline_id"
                                                            name="discipline_id"
                                                            className="form"
                                                            styles={customStyles}
                                                            value={changedDisciplineData}

                                                            options={getDisciplinesData && getDisciplinesData.map(discipline => ({
                                                                value: discipline.discipline_id,
                                                                label: discipline.discipline_name
                                                            }))}

                                                            onChange={handleDisciplineChange}
                                                        />
                                                    </div>

                                                    <div className="col-md-2">

                                                        <label>Status</label>
                                                        <Select
                                                            maxMenuHeight={200}
                                                            menuPlacement="auto"
                                                            id="status_id"
                                                            name="status_id"
                                                            className="form"
                                                            styles={customStyles}
                                                            value={changedStatusData}
                                                            options={statusOptions}// Replace with actual options
                                                            onChange={handleStatusChange}
                                                            defaultValue=""
                                                        />
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="d-flex justify-content-end gap-2">
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary action-btn"
                                                                onClick={showCourseList}
                                                            >
                                                                Go
                                                            </button>

                                                            <button
                                                                type="button"
                                                                className="btn btn-secondary clear-btn btn-sm"
                                                                onClick={handleClearFields}
                                                            >
                                                                Clear
                                                            </button>
                                                        </div>




                                                    </div>
                                                </div>

                                            </div>



                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="col-xxl-12 col-xl-12 box-col-12">

                                                            <div className="sig-heading">
                                                                <h6>
                                                                    {displayCollegeName && (
                                                                        <>
                                                                            <b>Selected College</b>: {changedCollegeName}
                                                                        </>
                                                                    )}
                                                                </h6>


                                                            </div>

                                                            <div className="container">
                                                                <div className="table-responsive ovrflw" style={{ overflowX: 'auto' }}>
                                                                    <div className="row justify-content-center">

                                                                        <div className="col-md-10 stat-out-bod">

                                                                            <table className="table-striped  table-bordered ex-table mb-10" ref={tableRef} id="dataTable" width="100%" style={{ textAlign: 'center', tableLayout: 'fixed' }}>
                                                                                <thead>
                                                                                    <tr className="col-cnt-tab-bg-clr" style={{ height: '40px' }}>

                                                                                        <th colSpan="3" style={{ textAlign: "center", verticalAlign: "middle", width: '50%', }}>Signature Specialization Course</th>
                                                                                        <th colSpan="3" style={{ textAlign: "center", verticalAlign: "middle", width: '50%', }}>Other Signature Course</th>
                                                                                    </tr>
                                                                                    <tr style={{ height: '40px' }}>
                                                                                        <th>Pending</th>
                                                                                        <th>Approved</th>
                                                                                        <th>Rejected</th>
                                                                                        <th>Pending</th>
                                                                                        <th>Approved</th>
                                                                                        <th>Rejected</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr>

                                                                                        <td>{getSignatureCourseData.pending}</td>
                                                                                        <td>{getSignatureCourseData.Approved}</td>
                                                                                        <td>{getSignatureCourseData.Rejected}</td>
                                                                                        <td>{getOtherSignatureCourseData.pending}</td>
                                                                                        <td>{getOtherSignatureCourseData.Approved}</td>
                                                                                        <td>{getOtherSignatureCourseData.Rejected}</td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>




                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form theme-form">
                                                <div className="custom-input">
                                                    {/* Add form inputs here */}

                                                    <div className="card-body">
                                                        <div className="card-body pdg1">
                                                            <div className="table-responsive ovrflw" style={{ overflowX: 'auto' }}>

                                                                <div className='row'>
                                                                    <div className='col-md-6 wdt' >
                                                                        <p>
                                                                            Showing {(currentPage - 1) * 50 + 1}{''}-
                                                                            {Math.min((currentPage - 1) * 50 + 50, total_count)} of {total_count} entries
                                                                        </p>
                                                                    </div>
                                                                    <div className='col-md-6 wdt' align='right'>
                                                                        <input
                                                                            type="text"
                                                                            value={searchQuery}
                                                                            onChange={handleSearchInputChange}
                                                                            placeholder="Search..."
                                                                            className='form-control'
                                                                        /></div></div>
                                                                <table className="display dataTable table-striped table-bordered ex-v-table" ref={tableRef}>
                                                                    <thead>
                                                                        <tr className="bg-primary">
                                                                            <th >Sl No &nbsp;</th>
                                                                            <th onClick={() => handleSort('admn_year')} style={{ textAlign: "center", verticalAlign: "middle" }} >Admin Year  &nbsp;
                                                                                {renderSortIcon('admn_year')}</th>
                                                                                <th onClick={() => handleSort('created_on')} style={{ textAlign: "center", verticalAlign: "middle" }} >Coordinator / Created On  &nbsp;
                                                                                {renderSortIcon('created_on')}</th>
                                                                            <th onClick={() => handleSort('discipline_name')} style={{ textAlign: "center", verticalAlign: "middle" }} >Discipline &nbsp;
                                                                                {renderSortIcon('discipline_name')}</th>
                                                                            <th onClick={() => handleSort('ugp_specialisation_name')} style={{ textAlign: "center", verticalAlign: "middle" }} >Specilization Name &nbsp;
                                                                                {renderSortIcon('ugp_specialisation_name')}</th>
                                                                            <th onClick={() => handleSort('course_name')} style={{ textAlign: "center", verticalAlign: "middle" }} >Semester - Course Name &nbsp;
                                                                                {renderSortIcon('course_name')}</th>
                                                                            {/* <th onClick={() => handleSort('exam_attendance')} style={{ textAlign: "center", verticalAlign: "middle" }} >Coordinator &nbsp;
                                                                                        {renderSortIcon('exam_attendance')}</th> 
                                                                                    <th onClick={() => handleSort('remarks')} style={{ textAlign: "center", verticalAlign: "middle" }} >Remarks &nbsp;
                                                                                        {renderSortIcon('remarks')}</th>
                                                                                    <th onClick={() => handleSort('entry_status')} style={{ textAlign: "center", verticalAlign: "middle" }} >Status &nbsp;
                                                                                        {renderSortIcon('entry_status')}</th>*/}
                                                                            <th >Action &nbsp;</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>

                                                                        {filteredAndSortedData && filteredAndSortedData.length > 0 ? (
                                                                            filteredAndSortedData.map((item, index) => {
                                                                                const serialNumber = (currentPage - 1) * 50 + index + 1;
                                                                                return (
                                                                                    <tr key={item.id}>
                                                                                        <td>{serialNumber}</td>
                                                                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>{item.admn_year}</td>
                                                                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>{item.faculty_name} ({item.created_on})</td>
                                                                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>{item.discipline_name}</td>
                                                                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>{item.ugp_specialisation_name}</td>
                                                                                        {/* <td style={{ textAlign: "center", verticalAlign: "middle" }}>{item.course_name}</td> */}

                                                                                        {/* course names in <li> */}

                                                                                        <td style={{ textAlign: "left", verticalAlign: "middle" }}>
                                                                                            <div className="">
                                                                                                <ul className="course-list-li ps-3 mb-0">
                                                                                                    {item.course_name?.split('|').map((course, idx) => {
                                                                                                        const course_code = (item.course_code?.split('|')[idx] || '').trim();

                                                                                                        const courseIds = item.id?.split('|') || [];
                                                                                                        const courseId = courseIds[idx] || '';
                                                                                                        const statuses = item.entry_status?.split('|') || [];
                                                                                                        const rawStatus = statuses[idx]?.trim() || '';

                                                                                                        const prinstatus = item.entry_status?.split('|')[idx]?.trim() || '';
                                                                                                        //console.log("prinstatus", prinstatus);

                                                                                                        let displayStatus = '';
                                                                                                        switch (rawStatus) {
                                                                                                            case 'entered':
                                                                                                                displayStatus = 'Draft';
                                                                                                                break;
                                                                                                            case 'forwareded_to_principal':
                                                                                                                displayStatus = 'Forwarded to Principal';
                                                                                                                break;
                                                                                                            case 'teacher_submited':
                                                                                                                displayStatus = 'Entry Completed';
                                                                                                                break;
                                                                                                            case 'principal_forwarded':
                                                                                                                displayStatus = 'Principal Forwarded to ACA16';
                                                                                                                break;
                                                                                                            case 'principal_reverted':
                                                                                                                displayStatus = 'Principal Reverted';
                                                                                                                break;
                                                                                                            case 'aca16_forwarded_to_bos':
                                                                                                                displayStatus = 'ACA16 Forwarded to BOS';
                                                                                                                break;
                                                                                                            case 'aca16_reverted_to_teacher':
                                                                                                                displayStatus = 'ACA16 Reverted to Teacher';
                                                                                                                break;
                                                                                                            case 'aca16_reverted_to_bos':
                                                                                                                displayStatus = 'ACA16 Reverted to BOS';
                                                                                                                break;
                                                                                                            case 'coursecode_generated_by_aca16':
                                                                                                                displayStatus = 'Course Code Generated';
                                                                                                                break;

                                                                                                            case 'final_approved_by_aca16':
                                                                                                                //displayStatus = 'Final Approved by ACA16';
                                                                                                                displayStatus = 'Approved';

                                                                                                                break;
                                                                                                            case 'bos_recommended_to_aca16':
                                                                                                                displayStatus = 'BOS recommended to ACA16';
                                                                                                                break;
                                                                                                            case 'bos_reverted_to_teacher':
                                                                                                                displayStatus = 'BOS Reverted to Teacher';
                                                                                                                break;
                                                                                                            case 'bos_rejected_course':
                                                                                                                displayStatus = 'BOS Rejected';
                                                                                                                break;
                                                                                                            default:
                                                                                                                displayStatus = rawStatus.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
                                                                                                        }

                                                                                                        const badgeClass = getStatusBadgeClass(rawStatus);

                                                                                                        return (
                                                                                                            <li
                                                                                                                key={idx}
                                                                                                                className="course-item-li"
                                                                                                                style={{
                                                                                                                    cursor: 'pointer',
                                                                                                                    display: 'flex',
                                                                                                                    flexDirection: 'column',
                                                                                                                    gap: '6px',
                                                                                                                    paddingBottom: '10px'
                                                                                                                }}
                                                                                                                onClick={() => getCourseDetails(courseId)}
                                                                                                            >
                                                                                                                <div className="pdg16" style={{ fontWeight: '500' }}>
                                                                                                                    {course.trim()}
                                                                                                                </div>
                                                                                                                {course_code && course_code.length > 0 && (
                                                                                                                    <div className="pdg16" style={{ fontWeight: '500', border: '1px solid #54ba4a', borderRadius: '7px' }}>
                                                                                                                        {course_code}
                                                                                                                    </div>
                                                                                                                )}
                                                                                                                <div className="pdg17">
                                                                                                                    <span className={`badge ${badgeClass}`} style={{ fontSize: '0.8rem' }}>
                                                                                                                        {displayStatus}
                                                                                                                    </span>
                                                                                                                </div>
                                                                                                                {(prinstatus === 'aca16_forwarded_to_bos' || prinstatus === 'aca16_reverted_to_bos') && (
                                                                                                                    <div>
                                                                                                                        <i
                                                                                                                            className="fa fa-rotate-left text-primary plus-icon"
                                                                                                                            aria-hidden="true"
                                                                                                                            title="Add Remarks and Revert to Faculty"
                                                                                                                            style={{ cursor: 'pointer', fontSize: '1.2rem' }}
                                                                                                                        ></i>

                                                                                                                    </div>
                                                                                                                )}

                                                                                                            </li>


                                                                                                        );
                                                                                                    })}
                                                                                                </ul>


                                                                                            </div>
                                                                                        </td>
                                                                                        {/* course names in <li> End */}



                                                                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                                                            <div className="kebab-menu position-relative">

                                                                                                {item.entry_status && (

                                                                                                    <div className="d-flex gap-2">
                                                                                                        {(() => {
                                                                                                            const statuses = item.entry_status?.split('|').map(s => s.trim()) || [];
                                                                                                            const allACA16Forward = statuses.length > 0 && statuses.every(s => s === 'aca16_forwarded_to_bos');
                                                                                                            const allACA16Reverted = statuses.length > 0 && statuses.every(s => s === 'aca16_reverted_to_bos');
                                                                                                            const notDraftFile = statuses.length > 0 && statuses.every(s => s !== 'entered');
                                                                                                            const courseIds = item.id;


                                                                                                            return (
                                                                                                                <>
                                                                                                                    {/* {allACA16Forward && (
                                                                                                                        <div className="icon-button1 forward-button" onClick={() => BOSForward(courseIds, item.course_type)}>
                                                                                                                            <i className="bi bi-arrow-right" title='Forward to BOS'></i>
                                                                                                                        </div>
                                                                                                                    )} */}
                                                                                                                    {allACA16Forward && (
                                                                                                                        <div
                                                                                                                            className="icon-button1 forward-button"
                                                                                                                            title="Recommended to ACA 16"
                                                                                                                            onClick={() => {
                                                                                                                                setCourseToForward({ id: courseIds, course_type: item.course_type });
                                                                                                                                setShowReccModal(true);
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            <i className="bi bi-send-fill fs-5" title="Recommend to ACA 16"></i>
                                                                                                                        </div>
                                                                                                                    )}
                                                                                                                    {(allACA16Forward || allACA16Reverted) && (
                                                                                                                        <div
                                                                                                                            className="icon-button1 reject-button"
                                                                                                                            title="Reject"
                                                                                                                            onClick={() => {
                                                                                                                                setCourseToForward({ id: courseIds, course_type: item.course_type });
                                                                                                                                setShowRejectModal(true);
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            <i className="bi bi-x-circle fs-5" title="Reject"></i>
                                                                                                                        </div>
                                                                                                                    )}

                                                                                                                    {notDraftFile && (



                                                                                                                        <div className="icon-button1 download-button" title='Download PDF' onClick={() => handleGeneratePDF(item.id, item.course_type)}>
                                                                                                                            <i className="bi bi-download" title='Download PDF'></i>
                                                                                                                        </div>
                                                                                                                    )}
                                                                                                                </>

                                                                                                            );
                                                                                                        })
                                                                                                            ()}

                                                                                                    </div>
                                                                                                )}
                                                                                            </div>
                                                                                        </td>

                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        ) : (
                                                                            <tr>
                                                                                <td colSpan="6" className="text-center py-3">No Data Found</td>
                                                                            </tr>
                                                                        )}
                                                                    </tbody>
                                                                </table>
                                                            </div>

                                                            {/* //pagination logic  */}

                                                            {totalPages > 1 && (
                                                                <nav aria-label="..." style={{ cursor: "pointer" }}>
                                                                    <ul className="pagination justify-content-center">
                                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                            <span className="page-link pgn-clr" onClick={handlePreviousPage}><i class="bi bi-arrow-left-circle-fill"></i></span>
                                                                        </li>
                                                                        <li className={`page-item`}>
                                                                            <span className="page-link pgn-clr" onClick={() => handlePageChange(1)}>1</span>
                                                                        </li>
                                                                        {currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                                                                        {[...Array(totalPages - 1).keys()].slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2).map((pageNumber) => (
                                                                            <li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
                                                                                <span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span>
                                                                            </li>
                                                                        ))}
                                                                        {currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}

                                                                        <li className={`page-item`}>
                                                                            <span className="page-link pgn-clr" onClick={() => handlePageChange(totalPages)}>{totalPages}</span>
                                                                        </li>

                                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                            <span className="page-link pgn-clr" onClick={handleNextPage}><i class="bi bi-arrow-right-circle-fill"></i></span>
                                                                        </li>
                                                                    </ul>
                                                                </nav>
                                                            )}



                                                        </div>
                                                    </div>



                                                    {showCourseModal && (
                                                        <div className="modal-backdrop" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.3)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1050 }}>

                                                            <div
                                                                className="modal-content"
                                                                style={{
                                                                    width: '500px',
                                                                    maxWidth: '95%',
                                                                    maxHeight: '90vh',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    backgroundColor: '#f8f9fa',
                                                                    borderRadius: '8px',
                                                                    border: '1px solid #dee2e6',
                                                                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                                                }}
                                                            >

                                                                <div className="modal-header" style={{ padding: '1rem', borderBottom: '1px solid #dee2e6', backgroundColor: '#e9ecef', position: 'sticky', top: 0, zIndex: 1 }}>
                                                                    <h5 className="modal-title m-0" style={{ color: '#495057', fontSize: '1.1rem' }}>
                                                                        <i className="bi bi-book me-2"></i>Course Details
                                                                    </h5>
                                                                    <button
                                                                        type="button"
                                                                        className="btn-close"
                                                                        onClick={() => setShowCourseModal(false)}
                                                                        aria-label="Close"
                                                                    />
                                                                </div>

                                                                <div
                                                                    className="modal-body p-0 activity-scroll-container activity-scroll-bar-container clg-card-ht "
                                                                    style={{ overflowY: 'auto', flex: 1 }}
                                                                >

                                                                    {selectedCourse && (
                                                                        <table className="table table-bordered m-0">
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td style={{ width: '30%', backgroundColor: '#f8f9fa', fontWeight: '500', verticalAlign: 'top' }}>Course Name</td>
                                                                                    <td style={{ wordBreak: 'break-word', padding: '0.75rem' }}>{selectedCourse.name}
                                                                                        <input type="hidden" name="courseid" id="courseid" value={selectedCourse.courseid} />
                                                                                    </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td style={{ backgroundColor: '#f8f9fa', fontWeight: '500', verticalAlign: 'top' }}>Semester</td>
                                                                                    <td style={{ wordBreak: 'break-word' }}>{selectedCourse.semester}</td>
                                                                                </tr>
                                                                                <tr>

                                                                                    <td style={{ backgroundColor: '#f8f9fa', fontWeight: '500', verticalAlign: 'top' }}>Remarks</td>
                                                                                    <td style={{ wordBreak: 'break-word' }}>
                                                                                        <div style={{ border: '1px solid #b0b1b3', padding: '10px' }}>

                                                                                            {selectedCourse.remarks.length > 0 ? (
                                                                                                <ul className="mb-0 ps-3" style={{ listStyleType: 'disc' }}>
                                                                                                    {selectedCourse.remarks.map((r, idx) => (
                                                                                                        <li key={idx}>
                                                                                                            <strong>{r.name}</strong> <em className="text-muted" style={{ fontSize: '0.85em' }}>({r.timestamp})</em><br />
                                                                                                            {r.remark}
                                                                                                        </li>
                                                                                                    ))}
                                                                                                </ul>
                                                                                            ) : 'N/A'}
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td style={{ backgroundColor: '#f8f9fa', fontWeight: '500', verticalAlign: 'top' }}>Add Remark</td>

                                                                                    <td>
                                                                                        <textarea
                                                                                            name="remark"
                                                                                            id="remark"
                                                                                            className="form-control"
                                                                                            rows="3"
                                                                                            placeholder="Enter your remark here..."
                                                                                            onChange={(e) => setNewRemark(e.target.value)}
                                                                                            value={newRemark}
                                                                                        />
                                                                                    </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td style={{ backgroundColor: '#f8f9fa', fontWeight: '500', verticalAlign: 'top' }}>Status</td>
                                                                                    <td style={{ wordBreak: 'break-word' }}>
                                                                                        <div
                                                                                            className={`badge ${getStatusBadgeClass(selectedCourse.status)}`}
                                                                                            style={{ fontSize: '0.9rem', padding: '0.4em 0.6em' }}
                                                                                        >

                                                                                            {selectedCourse.status
                                                                                                ? {
                                                                                                    entered: 'Draft',
                                                                                                    forwareded_to_principal: 'Forwarded to Principal',
                                                                                                    teacher_submited: 'Entry Completed',
                                                                                                    principal_forwarded: 'Principal Forwarded to ACA16',
                                                                                                    principal_reverted: 'Principal Reverted',
                                                                                                    aca16_forwarded_to_bos: 'ACA16 Forwarded to BOS',
                                                                                                    aca16_reverted_to_teacher: 'ACA16 Reverted to Teacher',
                                                                                                    aca16_reverted_to_bos: 'ACA16 Reverted to BOS',
                                                                                                    //final_approved_by_aca16: 'Final Approved by ACA16',
                                                                                                    coursecode_generated_by_aca16: 'Course Code Generated',
                                                                                                    final_approved_by_aca16: 'Approved',
                                                                                                    bos_recommended_to_aca16: 'BOS Recommended to ACA16',
                                                                                                    bos_reverted_to_aca16: 'BOS Reverted to ACA16',
                                                                                                }[selectedCourse.status] ||
                                                                                                selectedCourse.status
                                                                                                    .split('_')
                                                                                                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                                                                                    .join(' ')
                                                                                                : 'Status Not Available'
                                                                                            }
                                                                                            {/* {selectedCourse.status 
                                                                                                .split('_')
                                                                                                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                                                                                .join(' ')} */}
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    )}
                                                                </div>

                                                                <div className="modal-footer" style={{ padding: '0.75rem 1rem', borderTop: '1px solid #dee2e6', backgroundColor: '#e9ecef', position: 'sticky', bottom: 0 }}>

                                                                    {selectedCourse && (selectedCourse.status === 'aca16_forwarded_to_bos' || selectedCourse.status === 'aca16_reverted_to_bos') && (
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-sm btn-danger"
                                                                            title="Revert to Faculty"
                                                                            onClick={() => setCourseRevert(selectedCourse.courseid, selectedCourse.status, newRemark)}
                                                                        >
                                                                            <i className="bi bi-arrow-counterclockwise me-1"></i> Revert
                                                                        </button>
                                                                    )}
                                                                    <button type="button" className="btn btn-sm btn-outline-secondary"
                                                                        onClick={() => setShowCourseModal(false)}
                                                                    >
                                                                        <i className="bi bi-x-lg me-1"></i> Close
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* BOS Recommended Modal */}
                                                    {showReccModal && (
                                                        <>
                                                            <div className="custom-modal-backdrop"></div>

                                                            <div className="custom-modal-wrapper">
                                                                <div className="custom-modal-container col-md-7">
                                                                    <div className="custom-modal-content p-4">
                                                                        <h4 className="text-center pb-2">
                                                                            Recommend Course(s)
                                                                        </h4>
                                                                        <p className="text-center small text-muted">
                                                                            This is an irreversible action, and the recommended course(s) will be forward to the University for approval.
                                                                        </p>

                                                                        <textarea
                                                                            className="form-control mb-3"
                                                                            rows="3"
                                                                            placeholder="Enter notes about the course"
                                                                            value={forwardNote}
                                                                            onChange={(e) => setForwardNote(e.target.value)}
                                                                        />
                                                                        {noteError && (
                                                                            <span className="text-danger small">Please enter a note before proceeding.</span>
                                                                        )}
                                                                        <div className="d-flex justify-content-center mt-3">
                                                                            <button
                                                                                className="btn btn-primary mx-2 btn-zoom-hover"
                                                                                onClick={() => BOS_Recommended()}
                                                                            >
                                                                                Recommend
                                                                            </button>

                                                                            <button
                                                                                className="btn btn-zoom-hover"
                                                                                style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }}
                                                                                onClick={handleReccCancel}
                                                                            >
                                                                                Cancel
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}

                                                    {/* BOS Recommended Modal  End*/}

                                                    {/* BOS Reject Modal */}


                                                    {showRejectModal && (
                                                        <>
                                                            <div className="custom-modal-backdrop"></div>

                                                            <div className="custom-modal-wrapper">
                                                                <div className="custom-modal-container col-md-7">
                                                                    <div className="custom-modal-content p-4">
                                                                        <h4 className="text-center pb-2">
                                                                            Reject Course(s)
                                                                        </h4>
                                                                        <p className="text-center small text-muted">
                                                                            This is an irreversible action, and the rejected course(s) cannot be resubmitted by the faculty.
                                                                        </p>

                                                                        <textarea
                                                                            className="form-control mb-3"
                                                                            rows="3"
                                                                            placeholder="Enter notes about the course"
                                                                            value={rejectNote}
                                                                            onChange={(e) => setRejectNote(e.target.value)}
                                                                        />
                                                                        {noteError && (
                                                                            <span className="text-danger small">Please enter a note before proceeding.</span>
                                                                        )}
                                                                        <div className="d-flex justify-content-center mt-3">
                                                                            <button
                                                                                className="btn btn-primary mx-2 btn-zoom-hover"
                                                                                onClick={() => BOS_Rejected()}
                                                                            >
                                                                                Reject
                                                                            </button>

                                                                            <button
                                                                                className="btn btn-zoom-hover"
                                                                                style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }}
                                                                                onClick={handleRejectCancel}
                                                                            >
                                                                                Cancel
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}

                                                    {/* BOS Reject Modal  End*/}
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </Template >
        </>
    );
}
